module.exports = function findDuplicates({
    data, 
    toStringConverter = a => a.toString(), 
    equals = (a, b) => a === b
}) {
    const concatenatedString = data.map(toStringConverter).join(",");
    let duplicates = [];
    data.forEach(d => {
        if (
            concatenatedString.split(toStringConverter(d)).length > 2 
            && !duplicates.find(it => equals(it, d))
        ) {
            duplicates.push(d);
        };
    });
    return duplicates;
}